import { UserApi } from '../../../api';
import { useContainer } from '../../useContainer';

const useTeamsDeactivation = () => {
    const userApi = useContainer(UserApi);

    const deactivateTeamsIntegration = (): Promise<void> => {
        return new Promise((resolve, reject) => {
            const { exec } = userApi.deactivateTeamsIntegration({
                onSuccess: () => resolve(),
                onError: error => reject(error),
            });

            exec();
        });
    };

    return { deactivateTeamsIntegration };
};

export default useTeamsDeactivation;
